export const STATS_TYPE = {
  totalPatient: 'totalPatient',
  reAdmission: 'reAdmission',
  tcmCompletionRatio: 'tcmCompletionRatio',
  currentHospitalization: 'currentHospitalization',
};
